import React, {Component} from 'react'

export default class DelayHelper {

    getDelayColor(d){
        let val = "";
        switch (d.ordinal) {
            case 0:
                val = "#64dd17";
                break;
            case 1:
                val = "#ff1744";
                break;
            case 2:
                val = "#ffab00";
                break;
        }
        return val;
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/DelayHelper.jsx